import React from 'react';
import { cn } from '../../utils/cn';
import { initials } from '../../utils/format';
const sizes = {
  xs: 'h-7 w-7 text-[10px]',
  sm: 'h-9 w-9 text-xs',
  md: 'h-11 w-11 text-sm',
  lg: 'h-14 w-14 text-base',
  xl: 'h-20 w-20 text-xl'
};
export function Avatar({
  name,
  src,
  size = 'md',
  className
}: {
  name: string;
  src?: string;
  size?: keyof typeof sizes;
  className?: string;
}) {
  if (src) {
    return <img src={src} alt={name} className={cn('shrink-0 rounded-full object-cover', sizes[size], className)} loading="lazy" data-id="element-930" data-mp="1gne7kmg7oogz" />;
  }
  return <span aria-hidden="true" className={cn('inline-flex shrink-0 items-center justify-center rounded-full bg-primary-soft font-semibold text-primary', sizes[size], className)} data-id="element-931" data-mp="1qm3sko3emp1g">
      {initials(name)}
    </span>;
}